import styled, { css } from 'styled-components';

import CompanySectionTitle from '~features/company/CompanySectionTitle';
import { useCompanySuggestion } from '~hooks/query/company/useCompanySuggestion';
import { useRouterQuery } from '~hooks/useRouterQuery';

import CompanyLogoCard from '../../CompanyLogoCard';
import { S } from '../style';

export default function SuggestionCompany() {
  const companyId = useRouterQuery('companyId');
  const { data, status } = useCompanySuggestion(companyId);

  if (status !== 'success' || !data) {
    return null;
  }

  return (
    <Wrapper>
      <CompanySectionTitle>동종업계 최근 조회 기업</CompanySectionTitle>
      <CardContainer>
        {data?.map((company) => (
          <CompanyLogoCard
            key={`suggestion-${company.id}`}
            companyId={company.id}
            location={company.location}
            locationCode={company.locationCode}
            companyName={company.name}
            PK_NM_HASH={company.PK_NM_HASH}
            href={`/company/${company.PK_NM_HASH}`}
            salary={company.salary}
            inlineCss={cssCard}
            data-attribute-id='company__search__click'
            data-search-value={company.name}
            data-search-type='동종업계 최근 조회 기업'
          />
        ))}
      </CardContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 30px;
  ${({ theme }) => theme.media.mobile} {
  }
`;

const CardContainer = styled.div`
  display: grid;
  flex-wrap: wrap;
  gap: 15px;
  grid-template-columns: 1fr 1fr;

  ${({ theme }) => theme.media.mobile} {
    grid-template-columns: auto;
  }
`;

const cssCard = css`
  flex: 0 0 50%;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};

  ${({ theme }) => theme.media.mobile} {
    flex: 0 0 100%;
  }
`;
